import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-verificar-email',
  imports: [],
  templateUrl: './verificar-email.html',
  styleUrl: './verificar-email.scss',
})
export class VerificarEmail implements OnInit {
  email: string = '';

  constructor(private route: ActivatedRoute, private router: Router) {}
  ngOnInit() {
    if (
      !this.route.snapshot.queryParamMap.get('email') ||
      !this.router.url.includes('?email=')
    ) {
      this.router.navigate(['/auth/recuperar-senha']);
    }
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
  }

  async reenvioCodigo() {
    const url = `${environment.apiUrl}/auth/recovery/code`;
    try {
      await axios.post(url, {
        email: this.email,
      });
    } catch (err: any) {
      if (err.response?.status === 400) {
        this.router.navigate(['/auth/recuperar-senha']);
      } else {
        console.error('Erro inesperado:', err);
      }
    }
  }
}
